<template>
  <div>
    <el-dialog :title="title" :visible="visible" @update:visible="(val) => $emit('update:visible', val)" width="650px" :modal-append-to-body="false" :show-close="false" center :top="`18px`">
      <div class="signature-container">
        <div class="signature-wrapper">
          <vue-signature ref="signature" :w="'600px'" :h="'300px'" :backgroundColor="'#fff'" :penColor="'#000'" />
        </div>
      </div>
      <div class="signature-actions" slot="footer">
        <el-button @click="clear" round>清除</el-button>
        <el-button @click="save" round type="primary">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueSignature from 'vue-signature'

export default {
  name: 'SignatureDialog',
  components: { vueSignature },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '簽名確認',
    },
  },
  data() {
    return {
      signatureData: null,
    }
  },
  methods: {
    clear() {
      this.$refs.signature.clear()
      this.signatureData = null
    },
    save() {
      this.signatureData = this.$refs.signature.save()

      if (this.$refs.signature.isEmpty()) {
        this.$message.warning('請先簽名再儲存')
        return
      }
      // 轉格式
      const blob = this.base64ToBlob(this.signatureData)
      const rid = Math.floor(Math.random() * 5000000)
      const file = new File([blob], `signature_${rid}.png`, { type: blob.type })

      const formData = new FormData()
      formData.append('files[]', file)
      formData.append('dir', 'signature')
      console.log('formData', formData)

      this.$emit('save-signature', formData)
      this.$emit('update:visible', false)
    },

    base64ToBlob(base64) {
      const arr = base64.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog--center .el-dialog__body {
  padding: 0px;
}

.signature-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature-wrapper {
  border: solid 2px #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 18px;
  padding: 8px;
  display: inline-block; /* 讓邊框緊貼內容 */
}

.signature-actions {
  margin-top: 12px;
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 16px;

  .el-button {
    flex: 1;
    margin-left: 0;
  }
}
</style>
